<template>
    <div class="main_box">
        <div class="main_box_content">
            <header>
                <div v-if="searchData.length" class="table-search">
                    <serach :list="searchData" @changeTitle="changeTitle" @seraching="seraching"
                        @judgeSearch="judgeSearch" />
                </div>
                <div v-if="showadd || $slots.actions" class="action_box">
                    <slot name="actions" />
                    <el-button type="primary" size="small" @click="addProductInfo" v-if="showadd">添加</el-button>
                </div>
            </header>
            <div class="infoBox" v-if="showInfo && !empytInfo" v-loading="isloadingInfobox">
                <template v-if="empytInfo">
                    <PageEmptyState />
                </template>
                <template v-else>
                    <div class="infoBox_content" v-for="(value, key, index) in info" :key="index">
                        <span>{{ key }}</span>
                        <span>{{ info[key] }}</span>
                    </div>
                </template>
            </div>
            <div class="table-scroll">
<setInfoheader :headerData="tableHeader" />

            <div class="tbody_box" v-loading="loading">
                <template v-if="tableData.length == 0">
                    <PageEmptyState />
                </template>
                <draggable v-else v-model="tableData" handle=".drag_icon" @start="dragStart" @end="dragEnd">
                    <template #item="{ element }">
                        <tableRow @editor="editor" @deleted="deleted" :app="element" :header="tableHeader" />
                    </template>
                </draggable>
            </div>
</div>
        </div>

</div>
</template>

<script setup lang="ts">

import PageEmptyState from '@/components/ui/PageEmptyState.vue'

    import { ref, onMounted, computed } from 'vue'

    import setInfoheader from '../../components/productSetInfo/setInfoheader.vue'
    import tableRow from '../../components/table/rowComponent.vue'
    import draggable from 'vuedraggable'

    import serach from '../table/serachComponent.vue'

    const emit = defineEmits<{
        (event: 'editor', info: any): void
        (event: 'deleted', info: any): void

        (event: 'add'): void
        (event: 'serach', data: any, type: string): void
        (event: 'judgeSearch', mark: string): void
        (event: 'changeTitle', item: any): void
    }>()
    const props = withDefaults(defineProps<{
        searchData?: any[]
        tableHeader: any
        tableData: any
        loading: boolean
        showInfo?: boolean

        info?: Record<string, any>
        showadd: boolean
        isloadingInfobox?: boolean
    }>(), { searchData: () => [], info: () => ({}) })

    const empytInfo = computed(() => {
        const list = Object.keys(props.info)
        if (list.length) {
            return false
        } else {
            return true
        }
    })

    const editor = (info: any) => {
        emit('editor', info)
    }

    const deleted = (info: any) => {
        emit('deleted', info)
    }

    const addProductInfo = (): void => {
        emit('add')
    }

    const seraching = (info: any, type: string) => {
        emit('serach', info, type)
    }

    const judgeSearch = (info: any, type: string) => {
        emit('judgeSearch', type)
    }

    const changeTitle = (title: any) => {
        emit('changeTitle', title)
    }

    const dragStart = (e: any) => {
        console.log('开始拖拽', e.item['_underlying_vm_'])
    }
    const dragEnd = (e: any) => {
        console.log('结束拖拽', e.item['_underlying_vm_'])
    }
    const tableData = computed(() => props.tableData)
    onMounted(() => { })

</script>

<style scoped>
.table-search { flex: 1; min-width: 0; }
.infoBox_content { display: flex; justify-content: space-between; align-items: start; gap: 16px; padding: 10px 12px; border-radius: var(--ui-radius); min-width: 0; }
.infoBox_content > span:first-child { flex-shrink: 0; color: var(--ui-text-muted); }
.infoBox_content > span:last-child { overflow-wrap: anywhere; text-align: right; }
</style>
